import { cloneDeep } from 'lodash'
import { MainActions } from './actions'

const initialState = {alive: true, count: 0}

const handleDummyAction = (state) => {
  const nuState = cloneDeep(state)
  nuState.count += 1
  console.log(nuState)
  return nuState
}

const mainReducer = (state, action) => {
  if (state === undefined) {
    state = initialState
  }
  switch (action) {
    case MainActions.DUMMY_ACTION:
      return handleDummyAction(state, action)
    default:
      return state
  }
}

export default mainReducer



// WEBPACK FOOTER //
// ./src/modules/main/reducer.js